var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconWtach02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 10"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 4.583,
  stroke: "#777",
  strokeWidth: 0.833
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#777",
  fillRule: "evenodd",
  d: "M4.583 2.917v2.955l2.113 1.045.387-.766-1.634-.808V2.917z",
  clipRule: "evenodd"
})));
export default SvgIconWtach02;